import {obtenerSha} from "./obtenerSha";

export const obtenerId = (correo) => {

    let id = obtenerSha(correo)
    return id
}